<template>
  <div v-if="detailsData">
    <!-- 询盘信息 -->
    <div class="RFQInfo">
      <div class="RFQdiv">
        <div class="RFQid">RFQ#{{detailsData.id}} <span v-if="detailsData.title">-{{ detailsData.title }}</span></div>
        <div class="rightBtn">
          <!-- <el-button class="linkBtn" icon="icon-call" @click="contactBuyer">联系采购</el-button> -->
          <el-button type="primary" class="promptly" @click="promptlyQuot" v-show="detailsData.isShowQuote">立即报价</el-button>
        </div>
      </div>
      <div class="compDiv"> 
        <div class="statusStrQuote" :class="'strStatusBnt'+detailsData.status"><i class="drop" :class="'statusBnt'+detailsData.status"></i>{{ detailsData.statusStr }}</div>
        <div v-if="daysRemainingFormat(detailsData.validDate)<=30&&[5,13,'5','13'].includes(detailsData.status)" class="validDate">剩余{{ daysRemainingFormat(detailsData.validDate) }}天结束报价</div>
        <div class="comp" @click="jump">{{ detailsData.buyerCompName }}</div>
      </div>
      <div class="RFQtag">
        <el-tag type="info" class="itemtag website" @click="leaveCompanyData(detailsData.siteUrl)" v-if="detailsData.siteUrl">{{ detailsData.siteUrl }}</el-tag>
        <el-tag type="info" class="itemtag" v-if="detailsData.capitalTypeStr">{{ detailsData.capitalTypeStr }}</el-tag>
        <el-tag type="info" class="itemtag" v-if="detailsData.buyerTypeStr">{{ detailsData.buyerTypeStr }}</el-tag>
        <template v-if="detailsData?.bizTypeStrList?.length>0">
          <el-tag v-for="item in detailsData.bizTypeStrList " :key="item" type="info" class="itemtag">{{ item }}</el-tag>
        </template>
        <el-popover
          v-if="detailsData.isCarbonFootprint"
          width="424px"
          popper-class="carbon-tip"
          class="box-item"
          placement="bottom-start" 
          trigger="hover">
          <div>含碳足迹报告需求。供应商报价中将包含为您定制的碳足迹报告。</div>
          <div>如无法提供该询盘相关碳足迹报告，供应商会第一时间联系采购</div>
          <template #reference>
            <el-tag type="success" class="itemtag carbon">   
              <img class="carbon-img" src="@/assets/image/common/carbon.png" alt=""/>碳足迹报告服务
            </el-tag>
          </template>
        </el-popover>
        
      </div>
    </div>
    <!-- 询盘报价要求 -->
    <div class="qoutRFQ">
      <div class="qoutTitle">询盘报价要求</div>
      <el-row :gutter="10">
        <el-col :span="12" class="itemcol">
          <div class="label">报价截止</div>
          <div class="value" v-if="detailsData.validDate" >{{ handleFormatDateAndTime(detailsData.validDate)  }}  </div>
        </el-col>
        <el-col :span="12" class="itemcol">
          <div class="label">报价货币</div>
          <div class="value">{{ detailsData.currencyStr }}</div>
        </el-col>
     </el-row>
     <el-row :gutter="10">
        <el-col :span="12" class="itemcol">
          <div class="label">保密协议</div>
          <div class="value">{{ detailsData.ndaTypeStr }}</div>
        </el-col>
        <el-col :span="12" class="itemcol">
          <div class="label">支付方式</div>
          <div class="value">{{paymentTerms (detailsData) }}</div>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="12" class="itemcol">
          <div class="label">询盘附件</div>
          <div class="value" v-if="detailsData.rfqAttachments.length>0">
            <!-- <div v-if="detailsData.ndaType==0||detailsData.isAcceptNda==1"> -->
              <div v-for="(item, index) in detailsData.rfqAttachments" :key="index" class="itemRfqAttach">
                <lookDownFile @accept="accept" :isAcceptNda="isAcceptNda" :isCanQuote="isCanQuote" :isLook="typeListLook.includes(getExtensions(item.originalName))" :name="item.originalName" :hashCode="item.hashCode" :detailsData="detailsData">
                 <i class="iconfont icon-attach"></i> {{ item.originalName }}
                </lookDownFile>
              </div>
            <!-- </div> -->
          </div>
          <div class="value" v-else>暂无</div>
        </el-col>
        <el-col :span="12" class="itemcol">
          <div class="label">货运信息</div>
          <div class="value" v-if="detailsData.freightTermsStr">{{ detailsData.freightTermsStr }}</div>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="12" class="itemcol">
          <div class="label">询盘说明</div>
          <div class="value" >{{ detailsData.remark || '--' }}
            <!-- 显示原文是接入国际化的时候才会有的功能,故暂时不要 -->
            <!-- <template v-if="detailsData.remark">
              <div class="activeLink" @click="reveal" >显示原文</div>
              <div class="explain" v-if="revealShow">
                Please include the shipping cost to be delivered in Chile.
              </div>
            </template> -->
          </div>
        </el-col>
        <el-col :span="12" class="itemcol">
          <div class="label">交货地点</div>
          <div class="value"> {{ detailsData.freightAddrVo.id?address(detailsData.freightAddrVo):'--' }} <span>{{detailsData.freightAddrVo.postCode  }}</span> </div>
        </el-col>
      </el-row>
    </div>
    <!-- 供应商要求 -->
     <div class="supplierRFQ">
        <div class="supplierTitle">供应商要求</div>
        <div class="supItem" v-if="detailsData.mainCategoryStr">
          <div class="label">询盘主工艺</div>
          <div class="value">{{ detailsData.mainCategoryStr }} <i class="iconfont " :class="detailsData.mainCategoryVerify==1?'icon-check':'icon-close'" ></i></div>
        </div>
        <div class="supItem" v-if="detailsData.localeRestriction">
          <div class="label">供应商所在区域限定</div>
          <div class="value">{{ detailsData.localeRestriction }}<i class="iconfont " :class="detailsData.localeRestrictionVerify==1?'icon-check':'icon-close'" ></i></div>
        </div>
        <div class="supItem" v-if="detailsData.limitCertificationStrList?.length>0">
          <div class="label">资质认证</div>
          <div class="value">{{ detailsData.limitCertificationStrList.join(',') }}<i class="iconfont " :class="detailsData.limitCertificationVerify==1?'icon-check':'icon-close'"></i></div>
        </div>
        <div class="supItem" v-if="detailsData.limitAnnualValueStr">
          <div class="label">年产值</div>
          <div class="value">{{ detailsData.limitAnnualValueStr }}<i class="iconfont " :class="detailsData.limitAnnualValueVerify==1?'icon-check':'icon-close'"></i></div>
        </div>
        <div class="supItem" v-if="detailsData.limitBusinessTypeStr">
          <div class="label">企业类型</div>
          <div class="value">{{ detailsData.limitBusinessTypeStr }}<i class="iconfont " :class="detailsData.limitBusinessTypeVerify==1?'icon-check':'icon-close'" ></i></div>
        </div>
        <div class="supItem" v-if="detailsData.limitEmployeeNumStr">
          <div class="label">雇员数量</div>
          <div class="value">{{ detailsData.limitEmployeeNumStr }}<i class="iconfont " :class="detailsData.limitEmployeeNumVerify==1?'icon-check':'icon-close'"></i></div>
        </div>
     </div>
  </div>
</template>
<script>
import moment from "moment";
import { onlineUrl } from '@/utils/config';
import lookDownFile from "@/components/common/zhenyun/lookDownFile.vue";
import { getExtension } from "@/utils/common";
import zhenyunOrderMinxis from "@/mixins/zhenyunOrder.js";
export default {
  mixins: [zhenyunOrderMinxis],
  props:{
    detailsData:{
      type:Object,
      default:null
    }
  },
  components:{lookDownFile},
  data() {
    return {
      revealShow:false,
      daysRemaining:0,
      typeListLook:['bmp', 'jpg', 'jpeg', 'png', 'gif', 'pdf', 'slddrw', 'sldprt', 'sldasm', 'prt', 'eprt', 'asm', 'dxf', 'dwg', 'x_t', 'igs', 'iges', 'step', 'stp', 'stl', 'ipt', 'iam', 'idb'],
      isSettledInfo:null,
      QuoteCompletenessData:null
    };
  },
  computed:{
    isAcceptNda(){
      return this.detailsData.ndaType==0||this.detailsData.isAcceptNda==1
    },
    isCanQuote(){
       return this.detailsData.isCanQuote==1?true:false
    }
  },
  methods:{
    getExtensions(name){
      return getExtension(name)
    },
    // 付款方式
    paymentTerms(item){
      // item.paymentTermsStr
      if(item.paymentTerms==8&&item.paymentOwn){
        return item.paymentOwn
      }else{
        return item.paymentTermsStr
      }
    },
    // 地址
    address(freightAddrVo){
      const { stateIdStr, provinceIdStr, cityIdStr, cityId} = freightAddrVo
      return [stateIdStr, provinceIdStr, !cityId ? undefined : cityIdStr].filter(Boolean).join('，')
    },  
    //日期格式化
    handleFormatDateAndTime(value) {
      if (value) {
        return moment(value).format("YYYY-MM-DD");
      }
      return "--";
    },
    // 计算还剩多少天,不足一天按一天算，截至到最后一天的23：59：59
    daysRemainingFormat(value){
      if (value) {
        let futureDate =moment(value).endOf('day');
        const now = moment()
        const daysRemaining = futureDate.diff(now,'day')+1;
        return daysRemaining
      }
      return "--";
    },
    // 点此去接受协议或入驻  与点击立即报价的流程类似
    accept(value){
      this.$emit('changeDetails','promptlyQuot',value)
    },
    // 显示原文
    reveal(){
      this.revealShow=true
    },
    // 联系采购
    contactBuyer(){
      this.$emit('changeDetails','contactBuyer','contactBuyer')
    },
    // 立即报价
  async promptlyQuot(){
      if(this.detailsData.isAcceptNda==2){
        return this.$message.warning('您的保密协议正在审核中，请耐心等待')
      }
      await this.getOnboarding(this.detailsData.clientId)
      await this.getQuoteCompleteness()
      try{
        const {
          authorizationLetter,
          intermediaryServiceAgreement,
          undertakingLetter,
          escrowAccount,
          platformServiceAgreement,
          myBankAuth,
          myBankChannel,
          canAuthChannels
        }=this.isSettledInfo
        // zhenyunFlag 是指多协议的，例如（甄云、长贸）
        const zhenyunFlag = [
          authorizationLetter,
          intermediaryServiceAgreement,
          undertakingLetter,
          escrowAccount,
        ].every(item=>item)
        // shukeFlag 是指单协议的，例如（数科、航天、中铁）
        const shukeFlag = [
          undertakingLetter,
          escrowAccount,
          platformServiceAgreement
        ].every(item=>item)
        if(!zhenyunFlag && [20,50].includes(this.detailsData.clientId) ){
          // 判断是否入驻？
          this.$emit('changeDetails','promptlyQuot',0)
          return 
        }
        if([30,70,90].includes(this.detailsData.clientId) && !shukeFlag){
          // 判断是否入驻？
          this.$emit('changeDetails','promptlyQuot',0)
          return 
        }
        // if(!myBankChannel&& escrowAccount) {
        //   return this.$router.push({ 
        //     name: "created-quote",
        //     params:{
        //       id:this.detailsData.encryptRfqId
        //     }
        //   });
        // }
        //判断是否完成网商银行授权
        if(myBankChannel && !myBankAuth && canAuthChannels.includes(this.detailsData.clientId+ '')){
          this.$emit('changeDetails','promptlyQuot',0)
          return 
        }
        // // 判断是否是网商且数科渠道可以直接报价
        // if(myBankChannel && canAuthChannels.includes(this.detailsData.clientId)){
        //   this.$emit('changeDetails','promptlyQuot',0)
        //   return 
        // }
        if(this.detailsData.isCanQuote!=1 || ![5, 13].includes(this.detailsData.status)){
          // 是否可以报价
          this.$emit('changeDetails','promptlyQuot',2)
          return
        }
        if(this.detailsData.quoteQuotaFull==1){
          // 报名是否满额
          this.$emit('changeDetails','promptlyQuot',3)
          return
        }
        if(this.detailsData.ndaType==2 && this.detailsData.isAcceptNda==0){
          // 判断是否二级保密协议
          this.$emit('changeDetails','promptlyQuot','nda2')
          return
        }
        if(this.detailsData.ndaType==1 && this.detailsData.isAcceptNda==0){
          // 判断是否一级保密协议
          this.$emit('changeDetails','promptlyQuot',1)
          return
        }
        
        if(this.QuoteCompletenessData.flag){
          // 创建报价
          this.$router.push({ name: "created-quote",params:{
            id:this.detailsData.encryptRfqId
          } });
          return
        }else{
          let url = onlineUrl+'/supplier-profile?u=1'
          window.open(url,'_target')
          return
        }
      }catch{
        console.error('❌ ~ getOnboarding ~ err:', err)
      }
    },
    // 跳转公司
    jump(){
      window.open( `${ onlineUrl }/comp/supplier/view-encrypt-buyer-profile/${this.detailsData.buyerCompIdAesId}`,'_blank');
    },
    // 公司网站
    leaveCompanyData(name){
      this.recordBehaviorActive(this.detailsData.compId)
      let url=name
      if (!/^(http|https):\/\//i.test(url)) {
        url = '//' + url
      }
      window.open(url,'_blank')
    },
  },
  mounted(){

  }
};
</script>
<style lang="scss" scoped>
.validDate{
  color: #ff081f;
  font-size: 14px;
  line-height: 22px;
  margin-right: 8px;
}
.itemRfqAttach{
  margin-bottom: 8px;
}
.promptly{
  background: #0863FF;
  border: none;
  height: 32px;
}
.promptly:hover{
  background: #0863FF !important;
  border: none;
}
.linkBtn{
  height: 32px;
}
.linkBtn:hover{
   background: #ffff;
}
.RFQInfo {
  border-bottom: 1px solid #eee;
  
  .RFQdiv {
    display: flex;
    font-size: 20px;
    font-weight: 700;
    margin-bottom: 8px;
    .RFQid {
      color: #222222;
    }
    .rightBtn {
      margin-left: auto;
      display: flex;
      align-items: center;
    }
  }
  .comp {
    // color: #222222;
    font-size: 14px;
    // margin-top: 3px;
    color: #0863ff;
    font-size: 14px;
    cursor: pointer;
  }
  .RFQtag {
    margin-top: 8px;
    .itemtag {
      margin-right: 8px;
      .carbon-img{
        width: 14px;
        position: relative;
        top: -2px;
        margin-right: 4px;
      }

       margin-bottom: 16px;
    }
      .carbon{
        cursor: pointer;
      }
    .website{
      cursor: pointer;
    }
    .website:hover{
      color: #0863ff;
      background: #F5F7FA;
    }
  }
}
.qoutRFQ{
   border-bottom: 1px solid #eee;
   padding: 16px 0;
   .qoutTitle{
    color: #222222;
    font-size: 16px;
    font-weight: 700;
    margin-bottom: 8px;
   }
   .itemcol{
    display: flex;
    margin-top: 8px;
    .label{
      width: 140px;
      color: #555555;
      font-size: 14px;
      line-height: 22px;
    }
    .value{
      color: #222222;
      font-size: 14px;
      line-height: 22px;
      flex: 1;
      white-space: pre-wrap;
      span{
        margin-left: 8px;
      }
      .activeLink{
        color: #0863ff;
        font-size: 14px;
        cursor: pointer;
      }
      .explain{
        width: 210px;
        border-radius: 4px;
        background: #F0F5FF;
        color: #222222;
        font-size: 14px;
        padding: 8px;
        margin-top: 4px;
      }
    }
   }
}
.supplierRFQ{
  border-bottom: 1px solid #eee;
  padding: 16px 0;
  .supplierTitle{
    color: #222222;
    font-size: 16px;
    font-weight: 700;
    margin-bottom: 8px;
  }
  .supItem{
    display: flex;
    align-items: center;
    margin-top: 8px;
    .label{
      color: #222222;
      font-size: 14px;
      line-height: 22px;
      width: 206px;
    }
    .value{
      color: #222222;
      font-size: 14px;
      line-height: 22px;
      .icon-check{
        margin-left: 8px;
        font-size: 16px;
        color: #20B820;
      }
      .icon-close{
        margin-left: 8px;
        font-size: 16px;
        color: #FF081F;
      }
    }
  }
}
.compDiv{
  display: flex;
  align-items: center;
  .statusStrQuote{
    border-radius: 20px;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 22px;
    padding: 0px 8px;
    margin-right: 8px;
    display: flex;
    align-items: center;
    .drop{
      width: 6px;
      height: 6px;
      border-radius: 50%;
      margin-right: 4px;
    }
    .statusBnt1 {
      background: #0052D9;
    }

    .statusBnt3,
    .statusBnt4,
    .statusBnt6 {
      background: #ff7b00;
    }
    .statusBnt7,
    .statusBnt12 {
      background: #FF3F3F;
    }

    .statusBnt5,
    .statusBnt8 {
      background: #00CA95;
    }

    .statusBnt9 {
      background: #00926C;
    }

    .statusBnt10,
    .statusBnt11,
    .statusBnt14 {
      background: #788DAF;
    }

    .statusBnt13 {
      background: #04A3FC;
    }
  }
}
 .strStatusBnt1 {
    color: #0052D9;
    background: #0052D91a;
  }

  .strStatusBnt3,
  .strStatusBnt4,
  .strStatusBnt6 {
    color: #ff7b00;
    background: #ff7b001a;
  }

  .strStatusBnt5,
  .strStatusBnt8 {
    color: #00CA95;
    background: #00ca951a;
  }

  .strStatusBnt7,
  .strStatusBnt12 {
    color: #FF3F3F;
    background: #FF3F3F1A;
  }

  .strStatusBnt9 {
    color: #00926c;
    background: #00926c1a;
  }

  .strStatusBnt10,
  .strStatusBnt11,
  .strStatusBnt14 {
    color: #788DAF;
    background: #788DAF1a;
  }

  .strStatusBnt13 {
    color: #04A3FC ;
    background: #04A3FC1a;
  }

</style>
